import _ from "lodash"
import React from "react"
import { connect } from "react-redux"
import BasicInfo from "./BasicInfo"
import IndustryInfo from "./IndustryInfo"
import * as ActionTypes from "@/stores/sale/actions"
import { withApi } from "@tencent/react-aio"
import { withRouter } from "react-router-dom"
import AdvertisingInfo from "./advertisingInfo"
import MessageBox from "@/components/MessageBox"
import DockedDialog from "@/components/DockedDialog"
import AccountInput from "@/business-components/sale/AccountInput"
import { Input, Button, ButtonGroup, FormGroup } from "@tencent/spaui"
import RegistrationTypeSelect from "@/components/RegistrationTypeSelect"
import RegistrationAdPlatformTypeSelect from "@/components/RegistrationAdPlatformTypeSelect.js"

// 编辑开户资料

class CreateAccountOrder extends React.Component {
  state = {
    type: "",
    orderId: "",
    ticketId: "",
    agencyUid: "",
    agencyAccountId: null, //已有账户获取
    submitDisabled: false,
    adAccountShow: false,
    editRegistration: false,
    accountStatus: "CUSTOMERSTATUS_UNKNOWN",
    registration_type: "REGISTRATION_NEW",
    registration_platform_type: "AD_PLATFORM_TYPE_GDT",
    customerId: "",
    customerMpUserName: "",
    unibdAppId: "",
    wechatAppId: "",
    basicInfo: {
      buyingType: "BUYINGTYPE_AUCTION",
      uname: "",
      websiteUrl: "",
      licenseNo: "",
      licenseImageUrl: "",
      areaCode: "",
      legalPersonName: "",
      legalPersonIdentityNo: "",
      legalPersonPositive: "",
      legalPersonNegative: "",
      tmallAdvertiserAdtype: 0,
      isLocalBusiness: 0,
    },
    industryInfo: {
      industry_id: "",
      industry_certifications_list: [],
    },
    advertisingInfo: {
      operation_mode: "",
      ad_platform_types: [],
      promoted_object: "",
      promotion_business: "",
      day_budget_promised: "",
      online_time_promised: "",
      effect_promised: "",
      memo_promised: "",
      competition: "",
      landing_page_url: "",
      creative_attachment_ids: { values: [] }, // 附件详细Id
      creativeAttachments: [], // 附件详细信息
      advertising_info_id: "",
    },
  }

  componentDidMount() {
    const { type, id, leadData, accountData = {} } = this.props
    const { orderType, disabled } = accountData

    // 销售自行开户or仅提交申请初始化
    if (orderType === "salesApply") {
      this.setState({ ticketId: id })
      if (disabled) {
        this.getAdvertisinDataAsync(id)
      } else {
        this.initCreateFromOrder(leadData)
      }
      return
    }

    if (type === "create") {
      this.setState({ type: "create", leadId: id })
      // todo：id为orderId
      this.initCreateFromOrder(leadData)
    } else if (type === "edit") {
      this.setState({ type: "edit", ticketId: id })
      // todo：id为ticketId

      this.getAdvertisinDataAsync(id)
    }
  }

  render() {
    const { type, submitDisabled, accountStatus, basicInfo, industryInfo, agencyUid, registration_type, registration_platform_type, customerId, customerMpUserName, unibdAppId, wechatAppId, advertisingInfo, memo, customer, customerStatus, customerError } = this.state
    const { show, accountData = {} } = this.props
    const { orderTitle, disabled, orderType } = accountData
    const title = orderTitle || (type === "create" ? "新建开户单" : "编辑开户单")
    const customerHelpBlock = customerStatus === "error" ? customerError : customerStatus === "success" ? customer.customerName : ""

    const disabledRegistrationTypeByEdit = orderType === "salesApply" ? disabled : type === "edit" ? true : false
    const disableRegistrationPlatformTypeEdit = orderType === "salesApply" ? disabled : type === "edit" ? true : false

    return (
      <DockedDialog title={title} escHide={true} show={true} hideHeader={false} onSubmit={this.handleSubmit} onClose={this.handleClose} onCancel={this.handleCancel}>
        <div className="info-des">
          <RegistrationTypeSelect disabled={disabledRegistrationTypeByEdit} value={registration_type} onChange={this.changeRegistrationType} />
        </div>
        <FormGroup>
          <span className="info-tt">投放平台</span>
          <div className="info-des">
            <RegistrationAdPlatformTypeSelect disabled={disableRegistrationPlatformTypeEdit} value={registration_platform_type} onChange={this.changeRegistrationPlatformType} />
          </div>
        </FormGroup>
        {/* { registration_type !== 'REGISTRATION_NEW' &&
        <FormGroup>
          <span className="info-tt">填写账户ID</span>
          <div className="info-des">
            <Input
              placeholder="请填写账户ID"
              value={customerId}
              onChange={this.changeCustomerId}
              onBlur={this.blurCustomerId}
            />
          </div>
        </FormGroup>} */}
        {registration_type !== "REGISTRATION_NEW" && (
          <FormGroup status={customerStatus} helpBlock={customerHelpBlock} className={"required"}>
            <label htmlFor="customerId">账户 ID：</label>
            <AccountInput
              key={customerMpUserName || customerId}
              acceptAccountId
              acceptMpUserName
              adPlatformType={this.state.registration_platform_type}
              value={unibdAppId || wechatAppId || customerMpUserName || customerId}
              onChange={this.handleChangeCustomerId}
              searchDataFromCs={this.blurCustomerId}
            />
          </FormGroup>
        )}
        <BasicInfo registrationType={registration_type} accountData={accountData} agencyUid={agencyUid} value={basicInfo} type={type} platformType={registration_platform_type} accountStatus={accountStatus} editRegistration={this.state.editRegistration} onChange={this.callback} onRef={this.basicInfoRef} />
        <IndustryInfo
          agencyUid={agencyUid}
          value={industryInfo}
          platformType={registration_platform_type}
          type={type}
          onChange={this.callback}
          onRef={this.industryInfoRef}
        />
        <AdvertisingInfo agencyUid={agencyUid} value={advertisingInfo} type={type} onChange={this.callback} onRef={this.advertisingRef} />
        <FormGroup>
          <label style={{ verticalAlign: "top" }}>填写申请说明：</label>
          <textarea style={{ verticalAlign: "top" }} className="spaui-input" rows="10" cols="200" value={memo} onChange={this.handleMemo} />
        </FormGroup>
      </DockedDialog>
    )
  }

  handleSubmit = () => {
    const { type, accountStatus } = this.state
    const { accountData = {} } = this.props
    const { orderType } = accountData

    // 销售自行开户or仅提交申请
    if (orderType === "salesApply") {
      this.updateStaff()
      return
    }

    if (type === "create") {
      this.createStaff()
    } else if (type === "edit") {
      this.updateStaff()
    }
  }

  handleClose = () => {
    this.props.onClose()
  }

  handleCancel = () => {
    this.props.onClose()
  }

  basicInfoRef = (ref) => {
    this.childBasicInfo = ref
  }

  industryInfoRef = (ref) => {
    this.childIndustryInfo = ref
  }

  advertisingRef = (ref) => {
    this.childAdvertisingInfo = ref
  }

  callback = (key, value) => {
    this.setState({ [key]: value })
  }

  handleMemo = (event) => {
    this.callback("memo", event.target.value)
  }

  changeCustomerId = (e, value) => {
    this.callback("customerId", value)
  }

  initCreateFromOrder = (leadData) => {
    const {
      lead: {
        company: { companyName, homepageUrl, areaId, industryId },
      },
    } = leadData

    this.setState(
      {
        basicInfo: {
          ...this.state.basicInfo,
          uname: companyName,
          websiteUrl: homepageUrl,
          areaCode: areaId,
        },
        industryInfo: {
          ...this.state.industryInfo,
          industry_id: industryId,
        },
      },
      (_) => {
        this.childIndustryInfo.onChangeIndustry(industryId)
      }
    )
  }

  clearAccountParams = () => {
    this.setState({
      agencyAccountId: null,
      customerId: "",
      customerMpUserName: "",
      unibdAppId: "",
      customerMpAppId: undefined,
      registration_platform_type: "AD_PLATFORM_TYPE_GDT",
      basicInfo: {
        ...this.state.basicInfo,
        buyingType: "BUYINGTYPE_AUCTION",
        licenseNo: "",
        licenseImageUrl: "",
        areaCode: "",
        legalPersonName: "",
        legalPersonIdentityNo: "",
        legalPersonPositive: "",
        legalPersonNegative: "",
        tmallAdvertiserAdtype: 0,
      },
      industryInfo: {
        industry_id: "",
        industry_certifications_list: [],
      },
      advertisingInfo: {
        operation_mode: "",
        ad_platform_types: [],
        promoted_object: "",
        promotion_business: "",
        day_budget_promised: "",
        online_time_promised: "",
        effect_promised: "",
        memo_promised: "",
        competition: "",
        landing_page_url: "",
        creative_attachment_ids: {
          values: [],
        },
        creativeAttachments: [],
        advertising_info_id: "",
      },
    })
  }

  handleChangeCustomerId = (e, value) => {
    console.log("value: ", value)
    const customerIdIsRequired = true
    if (customerIdIsRequired && value.value === "") {
      this.setState({
        customer: value.customer,
        customerStatus: "error",
        customerError: "必须填",
        error: "必须填",
      })
    } else {
      this.setState({
        customer: value.customer,
        customerStatus: value.status,
        customerError: value.error,
        error: value.error ? { message: value.error } : undefined,
      })
      if (value.customer) {
        this.setState({ customerId: value.customer.customerId })
        if (value.customer.mp) {
          if (value.value.startsWith("wx")) {
            this.setState({ wechatAppId: value.customer.mp.wechatAppId })
          } else {
            this.setState({ customerMpUserName: value.customer.mp.mpUserName })
          }
        }
        if (value.customer.unibd) {
          this.setState({ unibdAppId: value.customer.unibd })
        }
        if (value.customer.agencyAccountId) {
          this.setState({ agencyAccountId: value.customer.agencyAccountId })
        }
      } else {
        this.setState({
          customerId: null,
          unibdAppId: null,
          customerMpAppId: null,
          customerMpUserName: null,
          agencyAccountId: null,
        })
      }
      this.setState({ customerStatus: value.status })
      this.setState({ customerError: value.error })
    }
  }

  blurCustomerId = (id) => {
    const { customerStatus } = this.state

    if (customerStatus === "error" || id === "") {
      return
    } else {
      this.props.webApi
        .getAdvertiserInfo(id)
        .ajax()
        .then((res) => {
          console.log("res: ", res)

          const {
            account_status,
            edit_registration_type_enabled,
            area_code,
            buying_type,
            industry_certifications_list,
            industry_id,
            legal_person_identity_no,
            legal_person_name,
            legal_person_negative,
            legal_person_positive,
            license_image_url,
            license_no,
            tmall_advertiser_adtype,
            uid,
            uname,
            website_url,
            is_local_business,
          } = res

          this.props.webApi
            .getIndustryInfo(industry_id)
            .ajax()
            .then((qualification) => {
              qualification = JSON.parse(qualification)

              this.setState(
                {
                  accountStatus: account_status,
                  editRegistration: edit_registration_type_enabled === 1 ? true : false,
                  basicInfo: {
                    buyingType: buying_type,
                    uname: uname,
                    websiteUrl: website_url,
                    licenseNo: license_no,
                    licenseImageUrl: license_image_url,
                    areaCode: area_code,
                    legalPersonName: legal_person_name,
                    legalPersonIdentityNo: legal_person_identity_no,
                    legalPersonPositive: legal_person_positive,
                    legalPersonNegative: legal_person_negative,
                    tmallAdvertiserAdtype: tmall_advertiser_adtype,
                    isLocalBusiness: is_local_business,
                  },
                  industryInfo: {
                    industry_id: industry_id,
                    industry_certifications_list: industry_certifications_list,
                  },
                },
                () => {
                  /**
                   * @industry_id 行业id
                   * @qualification 该行业id下的行业资质（不带选择数据）
                   * @true 确认初始化
                   * @industry_certifications_list 选择的资质（勾选的checkbox，包括image数据）
                   */
                  this.childIndustryInfo.onChangeIndustry(industry_id, industry_certifications_list)
                }
              )
            })
            .catch((err) => {
              this.context.error("拉取信息失败", err.message)
            })
        })
        .catch((err) => {
          console.log("err: ", err)
          this.context.error("拉取信息失败", err.message)
        })
    }
  }

  getAdvertisinDataAsync = (id) => {
    this.props.webApi
      .getAdvertisingDetail(id)
      .ajax()
      .then((res) => {
        console.log("res: ", res)

        const {
          customer_id: customerId,
          memo,
          order_id,
          lead_id,
          edit_registration_type_enabled,
          registration_platform_type,
          registration_ticket_id,
          advertising_info,
          registration_info: { is_local_business, agency_uid, area_code, buying_type, industry_certifications_list, industry_id, legal_person_identity_no, legal_person_name, legal_person_negative, legal_person_positive, license_image_url, license_no, tmall_advertiser_adtype, uname, website_url },
        } = res;

        const {
          ad_platform_types,
          advertising_info_id,
          competition,
          creative_attachment_ids,
          creative_attachments,
          day_budget_promised,
          effect_promised,
          landing_page_url,
          memo_promised,
          online_time_promised,
          operation_mode,
          promoted_object,
          promotion_business,
        } = advertising_info || {};

        this.props.webApi
          .getIndustryInfo(industry_id)
          .ajax()
          .then((qualification) => {
            console.log('qualification', qualification)
            qualification = JSON.parse(qualification)
            this.setState(
              {
                orderId: order_id,
                leadId: lead_id,
                ticketId: registration_ticket_id,
                agencyUid: agency_uid,
                customerId: customerId,
                registration_platform_type: registration_platform_type,
                editRegistration: edit_registration_type_enabled === 1 ? true : false,
                basicInfo: {
                  buyingType: buying_type,
                  uname: uname,
                  websiteUrl: website_url,
                  licenseNo: license_no,
                  licenseImageUrl: license_image_url,
                  areaCode: area_code,
                  legalPersonName: legal_person_name,
                  legalPersonIdentityNo: legal_person_identity_no,
                  legalPersonPositive: legal_person_positive,
                  legalPersonNegative: legal_person_negative,
                  tmallAdvertiserAdtype: tmall_advertiser_adtype,
                  isLocalBusiness: is_local_business,
                },
                industryInfo: {
                  industry_id: industry_id,
                  industry_certifications_list: industry_certifications_list,
                },
                advertisingInfo: {
                  operation_mode: operation_mode,
                  ad_platform_types,
                  promoted_object: promoted_object,
                  promotion_business: promotion_business,
                  day_budget_promised: day_budget_promised,
                  online_time_promised: online_time_promised,
                  effect_promised: effect_promised,
                  memo_promised: memo_promised,
                  competition: competition,
                  landing_page_url: landing_page_url,
                  creative_attachment_ids: creative_attachment_ids ? creative_attachment_ids : { values: [] },
                  creativeAttachments: creative_attachments ? creative_attachments : [],
                  advertising_info_id: advertising_info_id,
                },
                memo: memo,
              },
              () => {
                /**
                 * @industry_id 行业id
                 * @qualification 该行业id下的行业资质（不带选择数据）
                 * @true 确认初始化
                 * @industry_certifications_list 选择的资质（勾选的checkbox，包括image数据）
                 */
                this.childIndustryInfo.onChangeIndustry(industry_id, qualification, true, industry_certifications_list)
              }
            )
          })
          .catch((err) => {
            this.context.error("拉取信息失败", err.message)
          })
      })
      .catch((err) => {
        console.log(err)
        this.context.error("拉取信息失败", err.message)
      })
  }

  clearErrorStatus = () => {
    this.childIndustryInfo.resetErrStatus()
    this.childBasicInfo.resetErrStatus()
    this.childAdvertisingInfo.resetErrStatus()
  }

  changeRegistrationPlatformType = (e, value) => {
    this.setState({
      registration_platform_type: value,
      isLocalBusiness: 0,
    })

    this.clearErrorStatus()
  }

  createStaff = () => {
    const { leadId, orderId, customerId, wechatAppId, registration_type, registration_platform_type, basicInfo, industryInfo, advertisingInfo, memo, agencyAccountId, customerMpUserName, unibdAppId } = this.state
    const industry_certifications_list = this.childIndustryInfo.formateIndustryInfo(industryInfo.industry_certifications_list)
    const { webApi } = this.props
    let validBasicRes, validIndustryRes, validAdvertisingRes
    const param = {
      // order_id: orderId,
      lead_id: leadId,
      customer_id: customerId,
      weChat_app_id: wechatAppId,
      mp_user_name: customerMpUserName,
      unibd_app_id: unibdAppId,
      memo: memo,
      registration_type: registration_type,
      registration_platform_type: registration_platform_type,
      registration_info: {
        // 开户信息
        agencyUid: agencyAccountId,
        buying_type: basicInfo.buyingType,
        uname: basicInfo.uname,
        website_url: basicInfo.websiteUrl,
        license_image_url: basicInfo.licenseImageUrl,
        license_no: basicInfo.licenseNo,
        area_code: basicInfo.areaCode,
        legal_person_name: basicInfo.legalPersonName,
        legal_person_identity_no: basicInfo.legalPersonIdentityNo,
        legal_person_positive: basicInfo.legalPersonPositive,
        legal_person_negative: basicInfo.legalPersonNegative,
        tmall_advertiser_adtype: basicInfo.tmallAdvertiserAdtype,
        // 投放信息
        industry_id: industryInfo.industry_id,
        industry_certifications_list: industry_certifications_list,
        is_local_business: registration_platform_type === "AD_PLATFORM_TYPE_GDT" && basicInfo.isLocalBusiness ? true : false,
      },
      advertising_info: advertisingInfo,
    }

    //去除为空的枚举值字段
    if (!param.advertising_info.ad_platform_types) {
      delete param.advertising_info.ad_platform_types;
    }

    if (!param.advertising_info.promoted_object) {
      delete param.advertising_info.promoted_object
    }

    if (!param.registration_info.agencyUid) {
      delete param.registration_info.agencyUid
    }

    if (registration_platform_type === "AD_PLATFORM_TYPE_GDT") {
      validBasicRes = this.childBasicInfo.validEachFieldIsEmpty("GDT")
      validIndustryRes = this.childIndustryInfo.validEachFieldIsEmpty("GDT")
      validAdvertisingRes = this.childAdvertisingInfo.validEachFieldIsEmpty("GDT")
    } else if (registration_platform_type === "AD_PLATFORM_TYPE_MP") {
      validBasicRes = this.childBasicInfo.validEachFieldIsEmpty("WeChat")
      validIndustryRes = this.childIndustryInfo.validEachFieldIsEmpty("WeChat")
      validAdvertisingRes = this.childAdvertisingInfo.validEachFieldIsEmpty("WeChat")
    }

    if (!(validBasicRes && validIndustryRes && validAdvertisingRes)) {
      return
    }

    this.setState({ submitDisabled: true })
    webApi
      .addAdvertisingAccount()
      .dispatchJson(ActionTypes.CREATE_CLIENT, {
        data: param,
      })
      .then((response) => {
        this.setState({ submitDisabled: false })
        if (response.registrationTicketId) {
          this.context.success("新建开户单成功")
          this.props.onClose()
          this.props.refreshTable()
        }
      })
      .catch((error) => {
        this.setState({ submitDisabled: false })
        this.context.error(error.message)
      })
  }

  updateStaff = () => {
    const { ticketId, registration_type, registration_platform_type, basicInfo, industryInfo, advertisingInfo, memo, customerId, wechatAppId, customerMpUserName, unibdAppId } = this.state
    const industry_certifications_list = this.childIndustryInfo.formateIndustryInfo(industryInfo.industry_certifications_list)
    const { webApi } = this.props
    let validBasicRes, validIndustryRes, validAdvertisingRes

    const param = {
      registration_ticket_id: ticketId,
      customer_id: customerId,
      weChat_app_id: wechatAppId,
      mp_user_name: customerMpUserName,
      unibd_app_id: unibdAppId,
      memo: memo,
      registration_type: registration_type,
      registration_platform_type: registration_platform_type,
      registration_info: {
        // 开户信息
        buying_type: basicInfo.buyingType,
        uname: basicInfo.uname,
        website_url: basicInfo.websiteUrl,
        license_image_url: basicInfo.licenseImageUrl,
        license_no: basicInfo.licenseNo,
        area_code: basicInfo.areaCode,
        legal_person_name: basicInfo.legalPersonName,
        legal_person_identity_no: basicInfo.legalPersonIdentityNo,
        legal_person_positive: basicInfo.legalPersonPositive,
        legal_person_negative: basicInfo.legalPersonNegative,
        tmall_advertiser_adtype: basicInfo.tmallAdvertiserAdtype,
        // 投放信息
        industry_id: industryInfo.industry_id,
        industry_certifications_list: industry_certifications_list,
        is_local_business: registration_platform_type === "AD_PLATFORM_TYPE_GDT" && basicInfo.isLocalBusiness ? true : false,
      },
      advertising_info: advertisingInfo,
    }

    //去除为空的枚举值字段
    if (!param.advertising_info.ad_platform_types) {
      delete param.advertising_info.ad_platform_types;
    }

    if (!param.advertising_info.promoted_object) {
      delete param.advertising_info.promoted_object
    }

    if (registration_platform_type === "AD_PLATFORM_TYPE_GDT") {
      validBasicRes = this.childBasicInfo.validEachFieldIsEmpty("GDT")
      validIndustryRes = this.childIndustryInfo.validEachFieldIsEmpty("GDT")
      validAdvertisingRes = this.childAdvertisingInfo.validEachFieldIsEmpty("GDT")
    } else if (registration_platform_type === "AD_PLATFORM_TYPE_MP") {
      validBasicRes = this.childBasicInfo.validEachFieldIsEmpty("WeChat")
      validIndustryRes = this.childIndustryInfo.validEachFieldIsEmpty("WeChat")
      validAdvertisingRes = this.childAdvertisingInfo.validEachFieldIsEmpty("WeChat")
    }

    if (!(validBasicRes && validIndustryRes && validAdvertisingRes)) {
      return
    }

    this.setState({ submitDisabled: true })
    webApi
      .updateAdvertisingAccount()
      .dispatchJson(ActionTypes.FETCH_ORDER_LIST, {
        data: param,
      })
      .then((response) => {
        this.setState({ submitDisabled: false })
        if (response.registrationTicketId) {
          this.context.success("更新账户成功")
          this.props.onClose()
          this.props.refreshTable()
        }
      })
      .catch((error) => {
        this.setState({ submitDisabled: false })
        this.context.error(error.message)
      })
  }

  changeRegistrationType = (e, value) => {
    this.callback("registration_type", value)
    this.clearAccountParams()
  }
}

function mapStateToProps(state, ownProps) {
  return {}
}

function mapDispatchToProps(dispatch) {
  return {}
}

export default withApi(withRouter(connect(mapStateToProps, mapDispatchToProps)(CreateAccountOrder)))

CreateAccountOrder.contextType = MessageBox
